import { AppointmentInfo, DefaultTestAppointmentInfo } from './appointmentInfo';
import {
  DefaultTestLocationDetails,
  LocationDetails,
} from './appointmentTypeLocation';
import {
  ContactInfoDetails,
  DefaultTestContactInfoDetails,
} from './contactInfoDetails';
import { DateTimeDetails, DefaultTestDateTimeDetails } from './dateTimeDetails';
import { DefaultTestPatientDetails, PatientDetails } from './patientDetails';
import { DefaultTestProviderDetails, ProviderDetails } from './providerDetails';
import {
  DefaultTestReviewAndSubmitDetails,
  ReviewAndSubmitDetails,
} from './reviewAndSubmitDetails';

export interface SchedulingDetails {
  providerDetails?: ProviderDetails;
  patientDetails?: PatientDetails;
  appointmentInfo?: AppointmentInfo;
  locationDetails?: LocationDetails;
  dateTimeDetails?: DateTimeDetails;
  contactInfoDetails?: ContactInfoDetails;
  reviewAndSubmitDetails?: ReviewAndSubmitDetails;
}

export const EmptySchedulingDetails: SchedulingDetails = {};

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestSchedulingDetails: SchedulingDetails = {
  providerDetails: { ...DefaultTestProviderDetails },
  patientDetails: { ...DefaultTestPatientDetails },
  appointmentInfo: { ...DefaultTestAppointmentInfo },
  locationDetails: { ...DefaultTestLocationDetails },
  dateTimeDetails: { ...DefaultTestDateTimeDetails },
  contactInfoDetails: { ...DefaultTestContactInfoDetails },
  reviewAndSubmitDetails: { ...DefaultTestReviewAndSubmitDetails },
};
